import { useTranslation } from 'react-i18next';

export const useFormattedBoolean = () => {
    const { t } = useTranslation('common');

    const formatBoolean = (value: boolean | string | undefined | null) => {
        if (value === true || value === 'true') return t('boolean.true');
        if (value === false || value === 'false') return t('boolean.false');

        return value;
    };

    return { formatBoolean };
};
